import { makeStyles } from '@material-ui/core/styles';
import { isiOS, isWeb } from '../../utils/utility';
import { fontClasses } from '../../fontStyles';


const makeStyle = makeStyles((theme) => ({
    qrScanBox: {
        width: "100vw",
        marginTop: isiOS() ? 'calc(64px + env(safe-area-inset-top))' : '64px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },

    scanDescription: {
        ...fontClasses.graphLabel1,
        color: `${theme.palette.tertiary.titleBox}`,
        marginTop: '70px',
        textAlign: 'center',
    },
    
    orSep: {
        ...fontClasses.graphLabel1,
        color: `${theme.palette.tertiary.titleBox}`,
        marginBottom: '12px',
        marginTop: '30px',
        textAlign: 'center',
    },

    enterSerialBtnBoxStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px',
    },

    buttonSerialStyle: {
        color: `${theme.palette.tertiary.provisionEnableButton} !important`,
        textAlign: 'center',
        width: "100%",
        padding: '10px',
        borderColor: `${theme.palette.tertiary.provisionEnableButton} !important`,
        border: "solid 1px",
        borderRadius: '10px',
        textTransform: 'none',
        background: 'transparent',
        fontSize: "16px",
    },
    buttonRetry:{
        color: `${theme.palette.tertiary.provisionEnableButton} !important`,
        textAlign: 'center',
        width: isWeb()?"440px" : "100%",
        padding: '10px',
        borderColor: `${theme.palette.tertiary.provisionEnableButton} !important`,
        border: "solid 1px",
        borderRadius: '10px',
        textTransform: 'none',
        background: 'transparent',
        fontSize: "16px",
        marginTop: '50px',
        margin: isWeb()?"0 auto" : "50px 0 0",
        "&.Mui-disabled": {
            borderColor: `${theme.palette.tertiary.disableApplyButtonBg} !important`,
            "& span": {
                color: `${theme.palette.tertiary.disableApplyButtonText} !important`,
            }
        }
    },
    commissioningSuccessContainer: {
        height: "100%",
        marginTop: isiOS() ? 'calc(64px + env(safe-area-inset-top))' : '64px',
        padding: '16px 16px 0px 16px',
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "center",
    },
    successImage: {
        marginBottom: '24px',
        width:'165px',
        height:'165px'
    },

    successText: {
        fontSize: '16px',
        fontWeight: 500,
        color: `${theme.palette.tertiary.titleBox} !important`,
        marginBottom: '12px',
    },
    hvacInputNameConatiner: {
        width: "98%",
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        marginTop: "20px"
    },
    hvacInputNameField: {
        width: "100%",
        "& label.MuiInputLabel-root": {
            ...fontClasses.body1,
            color: theme.palette.primary.inputLabelColor
        },
        "& input": {
            ...fontClasses.body2,
            color: theme.palette.primary.mainText2,
            borderColor: "#BABEC3",
        }
    },
    comissioningSubHeading:{
         ...fontClasses.popUpBody1,
        color: `${theme.palette.tertiary.titleBox} !important`,
        textAlign: "center"
    },
    progressiveLoader: {
        marginRight: '10px',
        color: `${theme.palette.tertiary.provisionEnableButton} !important`,
    },
    blueTick:{
       marginRight: '10px',
       display: 'flex' 
    },
    successSubText: {
        fontSize: '14px',
        color: `${theme.palette.tertiary.provisiningSubHeading} !important`,
        marginBottom: '24px',
    },

    buttonContainer: {
        display: "flex",
        justifyContent: "center",
        padding: '50px 16px 16px 16px',
    },
    buttonStyle: {
        width: isWeb() ?"440px" :"100%",
        backgroundColor: "#01B5DE !important",
        color: `${theme.palette.tertiary.timeCardBtn}`,
        textTransform: "none",
        borderRadius: "8px",
        padding: "12px 24px",
        fontSize: "16px !important",
        fontWeight: "500",
        textAlign: 'center',
        alignItems: 'center',
        opacity: '100% ',
        margin : isWeb() ?"0 auto" :"unset",
        "&:focus": {
            backgroundColor: "#01B5DE !important",
        },
        "&.Mui-disabled": {
            backgroundColor: `${theme.palette.tertiary.disableApplyButtonBg} !important`,
            borderColor: `${theme.palette.tertiary.disableApplyButtonBg} !important`,
            "& span": {
                color: `${theme.palette.tertiary.disableApplyButtonText} !important`,
            }
        }
    },
    loaderBtn: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: '100%',
        padding: '4px'
    },
    modelcontainer: {
        display: 'flex',
        flexDirection: 'column',
        width: isWeb() ? '70%' :'100%',
        height: isWeb() ? 'calc(100% - 150px)' : isiOS() ? 'calc(91vh - 64px - env(safe-area-inset-top))' : 'calc(91vh - 64px)',
        backgroundColor: `${theme.palette.tertiary.evDetailsBackgroundColor}`,
        position: 'absolute',
        top: isWeb() ? 'unset' : (isiOS() ? 'calc(64px + env(safe-area-inset-top))' : '64px'),
        overflowY: 'auto',
    },
    modelBody: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: `${theme.palette.tertiary.evDetailsBackgroundColor}`,
        flexGrow: '1'
    },
    DetailsContainer: {
        display: 'flex',
        flexDirection: 'column',
        margin: '8px 21px',
        '& .MuiFormLabel-root': {
            color: `${theme.palette.tertiary.inputLabel} !important`
        },
        '& .MuiFormLabel-root .Mui-disabled': {
            color: `${theme.palette.tertiary.inputLabel} !important`
        }
    },
    TrimDetalis: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginBottom: '24px',
        color: `${theme.palette.tertiary.NoEvDataMessage}`,

        "& .MuiInputBase-input": {
            fontSize: '13px',
            padding: '6px 0 7px',
            borderBottom: `1px solid ${theme.palette.tertiary.inputBorderBottom} !important`
        },
        "& .MuiInputLabel-formControl": {
            color: `${theme.palette.tertiary.inputText} !important`
        },
    },
    fieldEmtyErrorMessage: {
        color: `${theme.palette.tertiary.errorMessageColor}`,
        fontSize: '12px !important',
    },
    comissioningHeading: {
        ...fontClasses.title2,
        color: `${theme.palette.tertiary.headingText} !important`,
        padding: '36px 0px 16px 0px'
    },
    cardContainer:{background: theme.palette.primary.cardBackground,},
    instructionsContainer: {
        backgroundColor: `${theme.palette.tertiary.card} !important`,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        padding: '16px',
        borderRadius: '10px',
        marginTop: '22px',
    },
    instructionHeading:{
        ...fontClasses.body2,
        color: `${theme.palette.tertiary.headingText} !important`,
    },
    instructionSubheading:{
        ...fontClasses.body1,
        color: `${theme.palette.primary.lightColor} !important`,
        paddingTop: "4px",
    },
    tnc: {
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
        paddingTop: '12px',
        "& .MuiButtonBase-root.MuiCheckbox-root": {
            padding: "0px 10px 0px 0px",
        },
        "& .MuiSvgIcon-root": {
            fill: theme.palette.primary.text,
        },
        "& .MuiCheckbox-root.Mui-checked .MuiSvgIcon-root": {
            fill: "#01B5DE !important",
        },
    },

    tncDescription: {
        ...fontClasses.body1,
        color: `${theme.palette.tertiary.headingText} !important`,
    },
    errorMsg: {
        color: '#f44336 !important',
        fontSize: '12px',
        lineHeight: '16px',
        margin: '6px 0px 0px 0px',
        fontWeight: '400'
    },
    customContainer:{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'space-between',
        backgroundColor: `${theme.palette.primary.background}`,
    },
    linkButtonContainer:{
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
    },
    linkingFormContainer:{
        padding: '16px',
    },
    selectDropdown:{
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '16px',
        color:`${theme.palette.primary.mainHeading} !important`,
        width: '130px',
       '&:focus': {
            backgroundColor: 'transparent !important',
        },
        '& .MuiSelect-icon': {
            top: '10px'
        }
    },
    HqSection:{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'anchor-center',
        
        
        '& .deviceInfo': {
            display: 'flex',
            flexDirection: 'column',

            '& .device-type': {
                ...fontClasses.title2,
                color:theme.palette.primary.cardText,
            },

            '& .device-details': {
                ...fontClasses.graphLabel1,
                color:`${theme.palette.primary.cardText} !important`,
            },
        },
        '& .MuiFormControl-root':{
            '& .MuiInputBase-root': {
                '& .MuiSelect-icon':{
                    '& path':{
                        fill:`${theme.palette.primary.mainHeading} !important`,
                    }
                },
                '&:before':{
                     borderBottom:`1px solid ${theme.palette.primary.dropdownBorder}`,
                }
            }
            
        }
        
    },
    HdSection:{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        background: theme.palette.primary.background,
        padding: "12px 16px",
        borderRadius: "8px",
        marginTop: "16px",
        '& .deviceInfo': {
            display: 'flex',
            flexDirection: 'column',

            '& .device-type': {
                ...fontClasses.body1,
                color: `${theme.palette.primary.mainText} !important`
            },

            '& .device-details': {
                ...fontClasses.greySmallText,
                color: `${theme.palette.primary.mainHeading} !important`
            },
        },
        '& .MuiFormControl-root':{
            '& .MuiInputBase-root': {
                width:'114px',
                '& .MuiSelect-icon':{
                    '& path':{
                        fill:`${theme.palette.primary.mainHeading} !important`,
                    }
                },
                '&:before':{
                     borderBottom:`1px solid ${theme.palette.primary.dropdownBorder}`,
                }
            }
            
        }
    },
    bodyMainContainer:{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        background:`${theme.palette.primary.background}`,
    },
    popUpBox:{
        width: '100%',
    },
    popUpHeader:{
        height: "55px",
        borderBottom: "1px solid",
        display: "flex",
        alignItems: "center",
        fontSize: "16px",
        paddingLeft: "15px",
        fontWeight: "400"
    },
    popUpContent:{
        display: "flex",
        flexDirection: "column",
        alignItems:"center",
        padding: "20px 20px 10px",
    },
    popUpMessage:{
        display: "flex",
        flexDirection: "column",
        textAlign:"center",
        fontSize:"12px",
        fontWeight:"400",
        margin: "10px 0 20px 0",
        gap: "6px",
    },
    actionBtn:{
        fontSize:"14px",
        width: "180px",
        padding: "10px 20px",
        border: "1px solid",
        borderRadius: "12px",
        color: "white",
        background: "#01B5DE",
        textAlign: "center",
    },
    legendContainer:{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        color: `${theme.palette.primary.mainHeading}`,
        fontSize: '12px',
        lineHeight: '16px',
        fontWeight: 400,
        scale: isWeb()? 1.2 : 'unset',
        paddingLeft: isWeb()?'12px':0
    },
    grayBgContainer:{
        backgroundColor: `${theme.palette.primary.background}`,
    },
    connectionContainer:{
        display: 'flex',
        justifyContent:'space-between',
        alignItems: 'center',
        padding:'16px'
    },
    legendEditBtn: {
        color: '#01B5DE',
        fontSize: '16px',
        fontWeight: '500'
    },
    noDeviceCard:{
        background: theme.palette.primary.cardBackground,
        boxShadow: '0 18px 40px rgba(16, 24, 40, 0.06)',
        margin:'40px 16px 16px 16px',
        textAlign:'center'
    },
    noDeviceIconSection: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '5px',
        fontSize: isWeb()?'20px':'16px',
        color: theme.palette.primary.cardText,
        fontWeight: 500,
        lineHeight: '24px',
        marginBottom: isWeb()?'8px':0,
        '& svg':{
            width: isWeb()?'18px':'14px',
            height: isWeb()?'18px':'14px',
            '& path':{
                fill:theme.palette.primary.cardText,
            }
        }
    },
    smallText:{
        fontSize: isWeb()?'16px':'12px',
        lineHeight: '16px',
        fontWeight: 400,
        color: theme.palette.primary.cardText,
    },
    nextHardwareInstallationContainer:{
        background: theme.palette.primary.cardBackground,
        padding: '16px',
        display: 'flex',
        margin: '40px 0 0 0',
        borderRadius: '8px',
        flexDirection: 'column',
        gap: '20px',
        width: 'calc(100% - 48px)',
        color:theme.palette.primary.text,
    
        '& .title': {
            ...fontClasses.body2,
        },

        '& .subtitle': {
            ...fontClasses.body1,
        }
    },



    
}));


export { makeStyle };
